export default __webpack_public_path__ + "static/mladapobuda_img2-5194fc2b76386cf4459c3c79b7859975.gif";